import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import TableContainer from 'src/components/Table/TableContainer';
import LoadingRows from 'src/components/Table/LoadingRows';
import NoDataCell from 'src/components/NoDataCell';
import { pagesText } from 'src/constants/pagesText';
import { useNavigate } from 'react-router-dom';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { WDAC_APP_PREVIOUS_PATH } from 'src/pages/wdac-results/tabs/Win32Apps/constants';
import { tableRowColor } from 'src/constants/table';
import { formatRelativeDays } from 'src/utils/formatTime';

const DeviceReadinessAppsTable = ({
  items = [],
  isLoading,
  isFetchingNextPage,
  sentryRef,
}) => {
  const navigate = useNavigate();

  const filteredItems = useMemo(() => {
    return items.filter(item => {
      const name = (item?.arpDisplayName || '').toLowerCase();
      return !name.includes('log collector');
    });
  }, [items]);

  const navigateToApps = appId => {
    const currentPath = window.location.pathname;
    sessionStorage.setItem(WDAC_APP_PREVIOUS_PATH, currentPath);
    navigate(`${PORTAL_ROUTE}/wdac-apps/${appId}/general`);
  };

  return (
    <TableContainer styles={{ maxHeight: '360px' }}>
      <Table stickyHeader>
        <TableHead sx={{ backgroundColor: '#3f3f3f' }}>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Version</TableCell>
            <TableCell>Publisher</TableCell>
            <TableCell>Last Seen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ backgroundColor: '#4B4B4B' }}>
          {isLoading ? (
            <LoadingRows columnCount={4} rowCount={4} />
          ) : (
            <>
              {filteredItems.map((row, index) => (
                <TableRow
                  key={row.id}
                  ref={index === filteredItems.length - 1 ? sentryRef : null}
                  onClick={() => navigateToApps(row.id)}
                  sx={{
                    cursor: 'pointer',
                    '&:nth-of-type(even)': {
                      backgroundColor: tableRowColor,
                    },
                  }}>
                  <TableCell>{row.arpDisplayName}</TableCell>
                  <TableCell>{row.arpDisplayVersion}</TableCell>
                  <TableCell>{row.arpPublisher}</TableCell>
                  <TableCell>{formatRelativeDays(row.lastSeenDate)}</TableCell>
                </TableRow>
              ))}
              {!isLoading && isFetchingNextPage && <LoadingRows columnCount={4} rowCount={2} />}
              {!isLoading && !filteredItems.length && (
                <NoDataCell colSpan={4}>{pagesText.noDataFound}</NoDataCell>
              )}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

DeviceReadinessAppsTable.propTypes = {
  items: PropTypes.array,
  isLoading: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool,
  sentryRef: PropTypes.any,
};

export default DeviceReadinessAppsTable;
